import type { SVGProps } from 'react';
import * as React from 'react';

const ArrowUpTrayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/arrow-up-tray">
      <g id="Icon">
        <path
          d="M11.1 15.9C11.1 16.3971 11.503 16.8 12 16.8C12.4971 16.8 12.9 16.3971 12.9 15.9L12.9 5.5637L16.4457 9.31796C16.787 9.67933 17.3566 9.6956 17.718 9.35431C18.0793 9.01302 18.0956 8.44341 17.7543 8.08204L12.6543 2.68204C12.4843 2.50202 12.2476 2.4 12 2.4C11.7524 2.4 11.5157 2.50202 11.3457 2.68204L6.24571 8.08204C5.90442 8.4434 5.92069 9.01302 6.28206 9.35431C6.64343 9.6956 7.21304 9.67933 7.55433 9.31796L11.1 5.5637L11.1 15.9Z"
          fill="currentColor"
        />
        <path
          d="M4.20002 15.3C4.20002 14.8029 3.79708 14.4 3.30002 14.4C2.80297 14.4 2.40002 14.8029 2.40002 15.3V18.3C2.40002 20.1225 3.87748 21.6 5.70002 21.6H18.3C20.1226 21.6 21.6 20.1225 21.6 18.3V15.3C21.6 14.8029 21.1971 14.4 20.7 14.4C20.203 14.4 19.8 14.8029 19.8 15.3V18.3C19.8 19.1284 19.1284 19.8 18.3 19.8H5.70002C4.8716 19.8 4.20002 19.1284 4.20002 18.3V15.3Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default ArrowUpTrayIcon;
